import React from 'react'

const PublisherSolution = () => {
  return (
    <div>
      PublusherSolution
    </div>
  )
}

export default PublisherSolution
